import { render } from "./NewClass.vue?vue&type=template&id=0e9eb826&scoped=true"
import script from "./NewClass.vue?vue&type=script&lang=js"
export * from "./NewClass.vue?vue&type=script&lang=js"

import "./NewClass.vue?vue&type=style&index=0&id=0e9eb826&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e9eb826"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';
import QImg from 'quasar/src/components/img/QImg.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QTable,QInput,QIcon,QInnerLoading,QImg});
